export const CHECKOUT_URL = "https://platform.myfxpocket.com/login";
export const REGISTER_URL = "https://platform.myfxpocket.com/register";

export const SIZES = [5000, 10000, 25000, 50000, 100000];

export const PLANS = [
  {
    id: "two-step",
    name: "Two-Step",
    tag: "Most Popular",
    fees: { 5000: 44, 10000: 75, 25000: 150, 50000: 250, 100000: 500 },
    specs: [
      ["Profit Target", "Step 1: 10% · Step 2: 5%"],
      ["Max Daily Loss", "5% (Equity-based)"],
      ["Max Overall Loss", "10% (Fixed Equity-based)"],
      ["Min. Trading Days", "5 days per step (0 once funded)"],
      ["Payout Schedule", "Every 5 days"],
      ["Max Leverage", "1:100"],
      ["Profit Split", "80 / 20"],
      ["Consistency Rule", "None"],
    ],
  },
  {
    id: "one-step",
    name: "One-Step",
    tag: "Fast Track",
    fees: { 5000: 58, 10000: 99, 25000: 180, 50000: 320, 100000: 550 },
    specs: [
      ["Profit Target", "Step 1: 10%"],
      ["Max Daily Loss", "3% (Equity-based)"],
      ["Max Overall Loss", "6% (Fixed Equity-based)"],
      ["Min. Trading Days", "5 days (0 once funded)"],
      ["Payout Schedule", "Every 5 days"],
      ["Max Leverage", "1:50"],
      ["Profit Split", "80 / 20"],
      ["Consistency Rule", "None"],
    ],
  },
  {
    id: "instant",
    name: "Instant Funding",
    tag: "No Evaluation",
    fees: { 5000: 197, 10000: 395, 25000: 987, 50000: 1975, 100000: 3950 },
    specs: [
      ["Profit Target", "None — Direct Funding"],
      ["Max Daily Loss", "3% (Equity-based)"],
      ["Max Overall Loss", "5% (Trailing — never lowered after payout)"],
      ["Min. Trading Days", "5 days"],
      ["Payout Schedule", "Every 14 days"],
      ["Max Leverage", "1:40"],
      ["Profit Split", "80 / 20"],
      ["Consistency Rule", "None"],
    ],
  },
  {
    id: "instant-light",
    name: "Instant Light",
    tag: "New · Low Fee",
    sizes: [5000, 10000, 25000],
    fees: { 5000: 85, 10000: 160, 25000: 345 },
    specs: [
      ["Profit Target", "None — Direct Funding"],
      ["Max Daily Loss", "3% (Equity-based)"],
      ["Max Overall Loss", "5% (Trailing — never lowered after payout)"],
      ["Min. Trading Days", "5 days"],
      ["Payout Schedule", "Every 14 days"],
      ["Max Leverage", "1:40"],
      ["Profit Split", "80 / 20"],
      ["Consistency Rule", "25% rule applies"],
    ],
  },
  {
    id: "swing",
    name: "Swing",
    tag: "Holds Weekends",
    fees: { 5000: 65, 10000: 110, 25000: 240, 50000: 375, 100000: 750 },
    specs: [
      ["Profit Target", "Step 1: 10% · Step 2: 5%"],
      ["Max Daily Loss", "5%"],
      ["Max Overall Loss", "10%"],
      ["Min. Trading Days", "5 days per step (0 once funded)"],
      ["Trading Period", "Unlimited"],
      ["Max Leverage", "50% of standard"],
      ["Profit Split", "80 / 20"],
      ["Overnight & Weekend Holding", "Allowed"],
      ["News Trading", "Allowed — incl. major news"],
      ["Weekend Swap", "Triple Friday swap"],
    ],
  },
];

export const ADDONS = [
  { id: "split", label: "+10% Profit Split Increase", fee: 0.2 },
  { id: "drawdown", label: "+1% Drawdown Limits Increase", fee: 0.2 },
];

export const fmtSize = (n) => `$${n / 1000}K`;
export const fmtMoney = (n) =>
  "$" + n.toLocaleString("en-US", { maximumFractionDigits: 0 });
